export const reduceProductsResponse = data => {
  const productVersions = data.reduce((acc, product) => {
    product.productVersions.forEach(version => {
      acc[version.skuId] = version;
    });
    return acc;
  }, {});
  const skuMap = Object.values(productVersions).reduce((acc, productVersion) => {
    acc[productVersion.skuId] = productVersion;
    productVersion.quantityPackDetails.forEach(quantityPack => {
      acc[quantityPack.skuId] = quantityPack;
    });
    return acc;
  }, {});
  const products = data.reduce((acc, product) => {
    var _acc$product$id;
    const {
      id
    } = product;
    if (product.currentSkuId < (acc === null || acc === void 0 || (_acc$product$id = acc[product.id]) === null || _acc$product$id === void 0 ? void 0 : _acc$product$id.currentSkuId)) {
      return acc;
    }
    acc[id] = Object.assign({}, product, {
      productVersions: product.productVersions.map(({
        skuId
      }) => skuId)
    });
    return acc;
  }, {});
  const apiNameToProductId = Object.values(products).reduce((acc, {
    apiName,
    id
  }) => {
    acc[apiName] = id;
    return acc;
  }, {});
  const productLineLevelToProductId = Object.values(products).reduce((acc, {
    productLine,
    productLevel,
    id
  }) => {
    if (productLine) {
      acc[productLine] = Object.assign({}, acc[productLine], {
        [productLevel]: id
      });
    }
    return acc;
  }, {});
  const quantityPackApiNameToProductId = Object.values(productVersions).reduce((acc, productVersion) => {
    productVersion.quantityPackDetails.forEach(quantityPack => {
      const {
        productId,
        productApiName,
        quantityPackApiName
      } = quantityPack;
      if (quantityPackApiName) {
        acc[quantityPackApiName] = Object.assign({}, acc[quantityPackApiName], {
          [productApiName]: productId
        });
      }
    });
    return acc;
  }, {});
  return {
    productMap: products,
    productVersions,
    skuMap,
    apiNameToProductId,
    productLineLevelToProductId,
    quantityPackApiNameToProductId,
    rawProductList: data
  };
};